import { Component, OnInit,AfterViewInit } from '@angular/core';
import { HelperService } from '../../app.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CrudServiceService } from '../../../app/app-services/crud-service.service'
import * as CartActions from '../../services/cart-store/cart.action';
import * as fromCart from '../../services/cart-store/cart.reducer';
import { Store } from '@ngrx/store';
import { ProductModel } from '../../shared/models/product.model';
import { timeout } from 'q';
declare const require: any;
var qs = require('qs');
var assert = require('assert');
declare var $: any;

@Component({
    selector: 'app-product-detail',
    templateUrl: './product-detail.component.html',
    styleUrls: ['./product-detail.component.scss']
})
export class ProductDetailComponent implements OnInit,AfterViewInit {
    public productId = null;
    public submitingData: boolean = false;
    public isLoading: boolean = false;
    public productDescription: Array<ProductModel> = [];
    public featuredProductList: Array<ProductModel> = [];
    public imgList = [];
    public selectimage = null;
    public cartNumber: number = 0;
    public cartData;
    public productQuant: number = 1;
    public currentImg(img) {
        // console.log(img)
        if (img !== null) {
            this.selectimage = img
        } else {
            this.selectimage = this.selectimage
        }
    }

    constructor(private store: Store<fromCart.CartState>, private helperService: HelperService, private crud: CrudServiceService, private router: Router, private toastr: ToastrService, private activeRoute: ActivatedRoute, ) {
        let catId = window.location.href.split("/")
        this.activeRoute.params.subscribe((res: any) => {
            this.productId = res.id;
        })
        this.getProductById(this.productId);
        this.getSimilarProduct(catId[catId.length - 3]);
        this.checkUser()
    }

    ngOnInit() {
        

        this.router.routeReuseStrategy.shouldReuseRoute = function () {
            return false;
        };
    }

    ngOnDestroy(){
        
    }   

    ngAfterViewInit(){      

        this.activeRoute.params.subscribe(routeParams => {

            setTimeout(function(){
                if ( $('#product_slider').length ){
                    $("#product_slider").revolution({
                        sliderType:"standard",
                        sliderLayout:"auto",
                        delay:5000,
                        disableProgressBar:"on",
                        navigation: {
                            keyboardNavigation:"off",
                            keyboard_direction: "horizontal",
                            mouseScrollNavigation:"off",
                            onHoverStop:"off",
                            arrows: {
                                style:"uranus",
                                enable:true,
                                hide_onmobile:true,
                                hide_under:778,
                                hide_onleave:true,
                                hide_delay:200,
                                hide_delay_mobile:1200,
                                tmp:'',
                                left: {
                                    h_align:"left",
                                    v_align:"center",
                                    h_offset:20,
                                    v_offset:0
                                },
                                right: {
                                    h_align:"right",
                                    v_align:"center",
                                    h_offset:20,
                                    v_offset:0
                                }
                            }
                            ,
                            thumbnails: {
                                style:"erinyen",
                                enable:true,
                                width:80,
                                height:105,
                                min_width:80,
                                wrapper_padding:0,
                                wrapper_color:"#fff",
                                wrapper_opacity:"1",
                                tmp:'<span class="tp-thumb-over"></span><span class="tp-thumb-image"></span><span class="tp-thumb-title"></span>',
                                visibleAmount:10,
                                hide_onmobile:false,
                                hide_onleave:false,
                                direction:"horizontal",
                                span:true,
                                position:"outer-bottom",
                                space:17,
                                h_align:"center",
                                v_align:"top",
                                h_offset:0,
                                v_offset:0
                            }
                        },
                        gridwidth:370,
                        gridheight:520,
                        lazyType:"none",
                        shadow:0,
                        spinner:"spinner2",
                        stopLoop:"on",
                        stopAfterLoops:0,
                        stopAtSlide:1,
                        shuffle:"off",
                        autoHeight:"off",
                        hideThumbsOnMobile:"off",
                        hideSliderAtLimit:0,
                        hideCaptionAtLimit:0,
                        hideAllCaptionAtLilmit:0,
                        debugMode:false,
                        fallbacks: {
                            simplifyAll:"off",
                            nextSlideOnWindowFocus:"off",
                            disableFocusListener:false,
                        }
                    })
                }
                

                $(document).ready(function() {
                    
                });  
               
                $(window).resize(function(){});
            },3000); 
        });       
    }    

    public getProductById(id) {
        this.isLoading = true;
        if (id !== null) {
            this.crud.getData('product/info?productId=' + id).subscribe((res: any) => {
                if (res.responseCode == 200) {
                    this.productDescription = res.products;
                    this.selectimage = this.productDescription[0].defaultImage;
                    this.productDescription[0].quantity = 1;
                    this.isLoading = false;
                }
            }, error => {
                this.toastr.error('Something went wrong', 'Error', { timeOut: 3000 });
            })
        }
    }

    //smilar product
    public getSimilarProduct(catId) {
        // console.log(catId)
        this.crud.getData('product/category/list?categoryId=' + catId).subscribe((res: any) => {
            if (res.responseCode == 200) {
                this.featuredProductList = res.products;
                if (res.products.length > 8) {
                    this.catDetails = res.products.splice(0, 6);                    
                } else {
                    this.catDetails = res.products
                }
            }
        })
    }

    public checkUser() {
        if (localStorage.getItem("type") === "Regular" || localStorage.getItem("type") == undefined) {
            return false;
        } else {
            return true;
        }
    }

    //select quantity
    public selectQuant(value) {
        this.productQuant = value;
    }

    public catDetails = [{ title: " Collor Tees", image: "assets/img/pic5.png", subTitle: "Lorem Lorem Lorem", Price: 300 }, { title: " Collor Tees", image: "assets/img/pic3.png", subTitle: "Lorem Lorem Lorem", Price: 300 }, { title: "Printed Tees", image: "assets/img/pic4.png", subTitle: "Lorem Lorem Lorem", Price: 300 }, { title: "Striped", image: "assets/img/pic5.png", subTitle: "Lorem Lorem Lorem", Price: 300 }, { title: "Solid", image: "assets/img/pic3.png", subTitle: "Lorem Lorem Lorem", Price: 300 }, { title: " Collor Tees", image: "assets/img/pic5.png", subTitle: "Lorem Lorem Lorem", Price: 300 }, { title: " Collor Tees", image: "assets/img/pic3.png", subTitle: "Lorem Lorem Lorem", Price: 300 }, { title: "Printed Tees", image: "assets/img/pic4.png", subTitle: "Lorem Lorem Lorem", Price: 300 }, { title: "Striped", image: "assets/img/pic5.png", subTitle: "Lorem Lorem Lorem", Price: 300 }, { title: "Solid", image: "assets/img/pic3.png", subTitle: "Lorem Lorem Lorem", Price: 300 }, { title: " Collor Tees", image: "assets/img/pic5.png", subTitle: "Lorem Lorem Lorem", Price: 300 }, { title: " Collor Tees", image: "assets/img/pic3.png", subTitle: "Lorem Lorem Lorem", Price: 300 }]
   
    public addQty(){ this.productQuant++;}
    public substractQty(){ if(this.productQuant > 1){ this.productQuant--;} }

    public addToCart(code,isRelated,$event) {
        if(isRelated){
            var el = $($event.target).parents('.l_p_text').prev().find(".variation-option-size").children('select').val();            
            var options = this.getRelatedVariationDetail(el,code); 
        }else{
            var el = $($event.target).parents('.quantity').prev().find(".variation-option-size").children('select').val();
            var options = this.getColorAndSizeByVariation(el,code); 
        }       

        // console.log(localStorage.getItem("customerid"))
        if (localStorage.getItem("customerid") == undefined || localStorage.getItem("customerid") == null) {
            this.toastr.warning("Please login first", "Login is Required", { timeOut: 3000 })
        } else {
            fetch(this.crud.getEndPoint("cart/add"),
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': 'Basic c2hvcHB5OjExODk0MDY0'
                },
                body: qs.stringify({
                    email: localStorage.getItem("email"),
                    customerId: localStorage.getItem("customerid"),
                    productId: code,
                    variationId:el,
					color:options.color,
					size:options.size,
                    quantity: this.productQuant
                })
            }).then(response => response.json())
            .then(response => {
                if (response.responseCode == "200") {
                    // console.log("added", response)
                    this.toastr.success(response.responseMessage, response.description, { timeOut: 3000 });
                    this.router.navigate(['/cart-page'])
                }
                 else{
                   this.toastr.error(response.responseMessage, response.description, { timeOut: 3000 });
                }
            }).catch(error => console.error('Error:', error))
        }
    }

    public productDetails(catId) {
        // console.log(catId)
        this.router.navigate(['/catId/' + catId.categoryId + '/product-detalil/' + catId.prdcode]);        
        this.getProductById(catId.prdcode); 
        window.scrollTo({top: 0, behavior: 'smooth'});
    }

    public addToWishList(prodId,$event) {
        var el = $($event.target).parents('.quantity').prev().find(".variation-option-size").children('select').val();
        var options = this.getColorAndSizeByVariation(el,prodId); 

        if (localStorage.getItem("customerid") == undefined || localStorage.getItem("customerid") == null) {
            this.toastr.warning("Please login first", "Login is Required", { timeOut: 3000 })
        } else {
            if (localStorage.getItem("customerid") !== null || localStorage.getItem("customerid") !== undefined) {
                fetch(this.crud.getEndPoint("wishlist/create"),
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'Authorization': 'Basic c2hvcHB5OjExODk0MDY0'
                    },
                    body: qs.stringify({
                        customerId: localStorage.getItem("customerid"),
                        variationId:el,
                        color:options.color,
                        size:options.size,
                        productId: prodId
                    })
                }).then(response => response.json())
                .then(response => {
                    if (response.responseCode == "200") {
                        this.helperService.wishListSubject.next(response.wishListItems)
                        this.toastr.success(response.responseMessage, response.description, { timeOut: 3000 });
                        this.router.navigate(['/wishlist']);
                        this.submitingData = false;
                    }
                }).catch(error => console.error('Error:', error));
                this.submitingData = false
            } else {
                this.toastr.warning("Please Login First", "Login In Required", { timeOut: 3000 })
                this.submitingData = false
            }
        }
    } 
    
    onSizeAndColorChange(variationId:string,prdcode:string,$event): void 
    {
       var options = this.getColorAndSizeByVariation(variationId,prdcode);                    
      
        //$($event.target).parent().siblings().find('select').val(variationId).change();      
    }

    getColorAndSizeByVariation(variationId,prdcode)
    {
        let color,size = null;
        
        const product = this.productDescription[0]; 

        for(let i = 0; i < product.variations.length; i++){
            if(product.variations[i].id == variationId){
                color = product.variations[i].color;
                size = product.variations[i].size;
            }           
        }    

        return {color,size};
    }

    getRelatedVariationDetail(variationId,prdcode)
    {
        
        let color,size = null;

        const products:ProductModel[] =  this.featuredProductList.filter((product) => {
            return product.prdcode == prdcode;
        });

        const product = products.length? products[0]: null;  
        for(let i = 0; i < product.variations.length; i++){
            if(product.variations[i].id == variationId){
                color = product.variations[i].color;
                size = product.variations[i].size;
            }           
        }    

        return {color,size};
    }
}
